<template>
  <div class="pop-alert pop-common-confirm">
      <div class="container">
          <div class="pop-header clearfix">
              <div class="f-left">알림</div>
              <div class="f-right">
                  <button type="button" class="pop-close" @click="closePopAlert();"><span class="blind">팝업닫기</span></button>
              </div>
          </div>
          <div class="pop-content">
              <p>
                  {{msg}}
              </p>
              <button type="button" class="pop-close btn-sm-border" @click="onCancelEvent();">{{cancelTitle}}</button>
              <button type="button" class="pop-close" @click="onConfirmEvent();">{{confirmTitle}}</button>              
          </div>
      </div>
  </div>
</template>
<script>

export default {
  props: ['confirm'],
  data(){
      return{
          msg:'',
          confirmTitle:'확인',
          cancelTitle:'취소',
          confirmHandler:null,
          cancelHandler:null,
      }
  },
  watch: {
    showPopup: function(value) {
        if(value) this.openPopAlert()
        else this.closePopAlert();
    }
  },
  methods:{
    onCancelEvent:function(){
        this.closePopAlert()
        if(this.cancelHandler)
            this.cancelHandler();    
    },
    onConfirmEvent:function(e){
        this.closePopAlert()    
        if(this.confirmHandler)
            this.confirmHandler();
    },
    show(msg,confirmHandler,cancelHandler){
      // this.postMessage = msg;
      this.msg = msg
      if(confirmHandler)this.confirmHandler = confirmHandler;
      if(cancelHandler)this.cancelHandler = cancelHandler;
      
      this.openPopAlert('common-confirm');
    },

    showConfirmTitle(msg,confirmHandler,cancelHandler,confirmTitle,cancelTitle){
      // this.postMessage = msg;
      this.msg = msg
      if(confirmHandler)this.confirmHandler = confirmHandler;
      if(cancelHandler)this.cancelHandler = cancelHandler;

      if(confirmTitle)this.confirmTitle = confirmTitle;
      if(cancelTitle)this.cancelTitle = cancelTitle;

      this.openPopAlert('common-confirm');
    }

  }
}
</script>


// WEBPACK FOOTER //
// src/components/common/PopCommonConfirm.vue